var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreditcard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 13") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.45,326a4.09,4.09,0,0,0,3.55,2h15.76a4.15,4.15,0,0,0,4.15-4.15V308.07a4.24,4.24,0,0,0-.88-2.59l204.1-185.71a45,45,0,0,0-37.73-20.5H64.05a45,45,0,0,0-45,45v182a45,45,0,0,0,45,45H195.72Z",
    fill: "#86c440"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268,305.52a4.16,4.16,0,0,1,.88,2.59v15.76a4.15,4.15,0,0,1-4.15,4.15H249a4.29,4.29,0,0,1-3.55-2l-49.73,45.23H434.36a45,45,0,0,0,45-45v-182a44.84,44.84,0,0,0-7.26-24.53Z",
    fill: "#4bb749"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.09,203.65h39.84a23.87,23.87,0,0,1,23.86,23.85v15.92a23.87,23.87,0,0,1-23.86,23.85H79.09a23.87,23.87,0,0,1-23.85-23.85V227.5A23.87,23.87,0,0,1,79.09,203.65Z",
    fill: "#117d3f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.89,263.84H77.13A17.87,17.87,0,0,1,59.26,246V224.91A17.87,17.87,0,0,1,77.13,207h43.76a17.87,17.87,0,0,1,17.87,17.87V246A17.89,17.89,0,0,1,120.89,263.84Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.64,303.93H67.48a4.94,4.94,0,0,0-4.94,4.94V323a5,5,0,0,0,4.94,5H81.64a5,5,0,0,0,5-5V308.87A5,5,0,0,0,81.64,303.93Z",
    fill: "#19a44c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113,303.93H98.87a4.94,4.94,0,0,0-4.94,4.94V323a5,5,0,0,0,4.94,5H113a5,5,0,0,0,5-5V308.87A5,5,0,0,0,113,303.93Z",
    fill: "#19a44c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142,303.93H127.79a5,5,0,0,0-5,4.94V323a5,5,0,0,0,5,5H142a5,5,0,0,0,4.94-5V308.87A4.94,4.94,0,0,0,142,303.93Z",
    fill: "#19a44c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.18,303.93H160a5,5,0,0,0-5,4.94V323a5,5,0,0,0,5,5h14.16a5,5,0,0,0,4.94-5V308.87A5,5,0,0,0,174.18,303.93Z",
    fill: "#19a44c"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "122.84 233.37 109.44 233.37 109.44 218.29 104.26 218.29 104.26 233.37 93.05 233.37 93.05 218.29 87.86 218.29 87.86 233.37 75.14 233.37 75.14 238.15 87.86 238.15 87.86 252.35 93.05 252.35 93.05 238.15 104.26 238.15 104.26 252.35 109.44 252.35 109.44 238.15 122.84 238.15 122.84 233.37",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.06,303.93H214.3a4.14,4.14,0,0,0-4.15,4.14v15.76A4.15,4.15,0,0,0,214.3,328h15.76a4.15,4.15,0,0,0,4.15-4.15V308.07A4.14,4.14,0,0,0,230.06,303.93Z",
    fill: "#19a44c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.45,303.93H245.69a4.14,4.14,0,0,0-4.14,4.14v15.76a4.14,4.14,0,0,0,4.14,4.15h15.76a4.15,4.15,0,0,0,4.15-4.15V308.07A4.17,4.17,0,0,0,261.45,303.93Z",
    fill: "#f9dee7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.45,303.93H245.69a4.14,4.14,0,0,0-4.14,4.14v15.76a4.21,4.21,0,0,0,.63,2.19l22.54-20.5A4.18,4.18,0,0,0,261.45,303.93Z",
    fill: "#19a44c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.69,328h15.76a4.15,4.15,0,0,0,4.15-4.15V308.07a4.24,4.24,0,0,0-.88-2.59L242.18,326A4.11,4.11,0,0,0,245.69,328Z",
    fill: "#117d3f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.37,303.93H274.61a4.14,4.14,0,0,0-4.15,4.14v15.76a4.15,4.15,0,0,0,4.15,4.15h15.76a4.14,4.14,0,0,0,4.14-4.15V308.07A4.16,4.16,0,0,0,290.37,303.93Z",
    fill: "#117d3f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.59,303.93H306.84a4.14,4.14,0,0,0-4.15,4.14v15.76a4.15,4.15,0,0,0,4.15,4.15h15.75a4.15,4.15,0,0,0,4.15-4.15V308.07A4.16,4.16,0,0,0,322.59,303.93Z",
    fill: "#117d3f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditcard);
export default __webpack_public_path__ + "static/media/creditcard.c924be7bdb472e5485094102373b9b6b.svg";
export { ForwardRef as ReactComponent };